import { Image, Square } from "@chakra-ui/react";
import currencyImage from "@/assets/images/currency.png";

const Currency = ({ size = 10, ...props }) => (
  <Square size={size} {...props}>
    <Image src={currencyImage} />
  </Square>
);
export default Currency;
